var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6442_25353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6.875H11.25L10.9375 12.5H9.0625L8.75 6.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0625 13.75H10.9375V15.625H9.0625V13.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.11728 2.31009C8.94972 0.896637 11.0503 0.896638 11.8827 2.31009L19.7111 15.6022C20.5371 17.0048 19.4933 18.75 17.8284 18.75H2.17163C0.506664 18.75 -0.537147 17.0048 0.28891 15.6022L8.11728 2.31009ZM10.2671 3.26161L18.0955 16.5537C18.1235 16.6014 18.1253 16.6296 18.125 16.6457C18.1245 16.668 18.1176 16.7015 18.0947 16.7396C18.0719 16.7779 18.0386 16.8113 17.9987 16.8345C17.9631 16.8552 17.9104 16.875 17.8284 16.875H2.17163C2.0896 16.875 2.03694 16.8552 2.00134 16.8345C1.96144 16.8113 1.92815 16.7779 1.90527 16.7396C1.88243 16.7015 1.87551 16.668 1.87503 16.6457C1.87468 16.6296 1.87647 16.6014 1.90453 16.5537L9.7329 3.2616C9.77794 3.18514 9.86059 3.125 10 3.125C10.1394 3.125 10.2221 3.18514 10.2671 3.26161Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6442_25353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9e2fd2692031f66004a1dfda559d2824.svg";
export { ForwardRef as ReactComponent };